// extracted by mini-css-extract-plugin
export default {"bluebook-is-teacher-preview":"bluebook-is-teacher-preview-IJJ7x"};